<template>
  <div v-if="claims && claims.length">
    <v-card-title class="py-0">
      <h2 class="text-h2 mt-10 mb-7">
        {{ $t("receiptsPanelStrings.title") }}
      </h2>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="claims"
        :items-per-page="-1"
        hide-default-footer
      >
        <template
          #item.date="{ item }"
        >
          {{ m(item.date, $t("commonStrings.dateDisplayFormat")) }}
        </template>

        <template
          #item.claimTypeId="{ item }"
        >
          {{ $t(`enums.receiptTypes.${item.claimTypeId}`) }}
        </template>

        <template #item.amount="{ item }">
          {{ toMoney(item.amount) }}
        </template>

        <template
          #item.comment="{item}"
        >
          {{ item.comment || $t('previewApplicationPageStrings.emptyValue') }}
        </template>

        <template #item.attachments="{ item }">
          <span class="white-space-nowrap">
            <receipt-attachments-modal
              :attachments="item.attachments"
              :application-id="applicationId"
            />
          </span>
        </template>

        <template #item.payingOrgs="{ item }">
          <v-tooltip location="top">
            <template #activator="{ props }">
              <span v-bind="props">
                <paying-orgs-label :paying-orgs="item.payingOrgs" />
              </span>
            </template>
            <ul>
              <li
                v-for="(name, index) in getNames(item.payingOrgs)"
                :key="index"
              >
                {{ name }}
              </li>
            </ul>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </div>
</template>

<script>
import readonlyPanel from "@/mixins/readonlyPanel";
import ReceiptAttachmentsModal from "./ReceiptAttachmentsModal";
import { mapGetters } from "vuex";
import PayingOrgsLabel from "@/views/applications/components/PayingOrgsLabel";
import { m } from '@/plugins/moment';
import { useOidc } from '@/composables/oidc';

export default {
  name: "ReceiptsPanel",
  components: {
    ReceiptAttachmentsModal,
    PayingOrgsLabel
  },
  mixins: [readonlyPanel],
  props: {
    claims: {
      type: Array,
      required: true
    },
    applicationId: {
      type: String,
      required: true
    },
    personId: {
      type: Number,
      required: true
    }
  },
  setup() {
    const { user } = useOidc();
    return { m, user };
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("receiptsPanelStrings.tableHeaders.date"),
          align: "left",
          sortable: false,
          value: "date"
        },

        {
          text: this.$t("receiptsPanelStrings.tableHeaders.expenseType"),
          align: "left",
          sortable: false,
          value: "claimTypeId"
        },

        {
          text: this.$t("receiptsPanelStrings.tableHeaders.payingOrgs"),
          align: "left",
          sortable: false,
          value: "payingOrgs"
        },

        {
          text: this.$t("receiptsPanelStrings.tableHeaders.attachment"),
          align: "left",
          sortable: false,
          value: "attachments"
        },

        {
          text: this.$t("receiptsPanelStrings.tableHeaders.comment"),
          align: "left",
          sortable: false,
          value: "comment"
        },

        {
          text: this.$t("receiptsPanelStrings.tableHeaders.amount"),
          align: "right",
          sortable: false,
          value: "amount"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      currentOrgId: "contextStore/orgId"
    })
  }
};
</script>
